import { render } from "./SmartModal.vue?vue&type=template&id=c8681ad8"
import script from "./SmartModal.vue?vue&type=script&lang=js"
export * from "./SmartModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/SmartModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c8681ad8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c8681ad8', __exports__)) {
    api.reload('c8681ad8', __exports__)
  }
  
  module.hot.accept("./SmartModal.vue?vue&type=template&id=c8681ad8", () => {
    api.rerender('c8681ad8', render)
  })

}


export default __exports__